import './AppLogo.css';

// Libraries
import DOMPurify from 'dompurify';
import { useMemo } from 'react';

const AppLogo = ({ app, isActive = true }) => {
    const appName = app.name.substr(0, 1).toUpperCase() + app.name.substr(1, 1).toLowerCase();
    const logo = app.connection_dependencies?.find((e) => e.field === 'LOGO')?.value;
    const sanitizedLogo = useMemo(
        () => (logo ? DOMPurify.sanitize(logo, { USE_PROFILES: { svg: true } }) : null),
        [logo]
    );

    return (
        <div className="app-logo" style={{ opacity: isActive ? 1 : 0.3 }}>
            {sanitizedLogo ? (
                <div className="app-icon" dangerouslySetInnerHTML={{ __html: sanitizedLogo }} />
            ) : (
                appName
            )}
        </div>
    );
};

export default AppLogo;
